import { createContext } from 'react';

export const ToolbarFilterPickerContext = createContext<{
  setFilterPickerActive: (state: boolean) => void;
  filterPickerActive: boolean;
}>(null);
